// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2933":"3463fa69","5047":"0022aefc"}[chunkId] + ".chunk.css";
};